import React from 'react';
import I18n from 'i18n-js';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import { RCBanner } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';
import MoneyLightning from '../../../images/money-lightning.svg';
// import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
// import { REVERB_PAYMENTS_EXPANSION_ARTICLE_ID } from '@reverbdotcom/commons/src/constants';

export default function ReverbPaymentsExpansionSellerOrderDetailsBanner() {
  // TODO: Update this with the correct article URL once the article is published
  const articleUrl = '#'; // useHelpCenterArticleUrl(REVERB_PAYMENTS_EXPANSION_ARTICLE_ID);

  return (
    <div className="reverb-payments-expansion-seller-order-details-banner">
      <RCBanner
        title={I18n.t('discovery.reverbPaymentsExpansionSellerOrderDetailsBanner.title')}
        image={MoneyLightning}
        content={
          <I18N text="discovery.reverbPaymentsExpansionSellerOrderDetailsBanner.subtitle">
            <CoreLink to={articleUrl} target="_blank" className="text-link" rel="noopener noreferrer">
              <I18N text="discovery.reverbPaymentsExpansionSellerOrderDetailsBanner.learnMore" />
            </CoreLink>
          </I18N>
        }
        cta={
          <CoreLink to={Paths.shopPoliciesEdit.expand({})} target="_blank" rel="noopener noreferrer">
            <I18N text="discovery.reverbPaymentsExpansionSellerOrderDetailsBanner.updatePayoutSettings" />
          </CoreLink>
        }
        theme="plain"
      />
    </div>
  );
}
